export default function Footer(){
    return (
        <footer class="ltn__footer-area  ">
            <div class="footer-top-area  section-bg-2 plr--5">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-xl-4 col-md-6 col-sm-6 col-12">
                            <div class="footer-widget footer-about-widget">
                                <div class="footer-logo">
                                    <div class="site-logo">
                                        <img src="img/logo-2.png" alt="Logo"/>
                                    </div>
                                </div>
                                <p>La società Ad Servizi Immobiliari, si occupa della intermediazione nella compravendita di immobili urbani, di terreni e di fabbricati rurali, per il tramite di agenti immobiliari regolarmente abilitati, offre ai clienti una serie mirata di servizi collegati e/o necessari alla compravendita e alla locazione.</p>
                                <div class="footer-address">
                                    <ul>
                                        <li>
                                            <div class="footer-address-icon">
                                                <i class="icon-placeholder"></i>
                                            </div>
                                            <div class="footer-address-info">
                                                <p>Piazza Giacomo Mancini 18, 87100 Cosenza</p>
                                            </div>
                                        </li>
                                        <li>
                                            <div class="footer-address-icon">
                                                <i class="icon-call"></i>
                                            </div>
                                            <div class="footer-address-info">
                                                <p><a href="tel:0984 24454">0984 24454</a></p>
                                            </div>
                                        </li>
                                        
                                    </ul>
                                </div>
                                <div class="ltn__social-media mt-20">
                                    <ul>
                                        <li><a href="#" title="Facebook"><i class="fab fa-facebook-f"></i></a></li>
                                        <li><a href="#" title="Twitter"><i class="fab fa-twitter"></i></a></li>
                                        <li><a href="#" title="Linkedin"><i class="fab fa-linkedin"></i></a></li>
                                        <li><a href="#" title="Youtube"><i class="fab fa-youtube"></i></a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-2 col-md-6 col-sm-6 col-12">
                            <div class="footer-widget footer-menu-widget clearfix">
                                <h4 class="footer-title">Chi Siamo</h4>
                                <div class="footer-menu">
                                    <ul>
                                        <li><a href="">Gruppo AD</a></li>
                                        <li><a href="">Contatti</a></li>

                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-2 col-md-6 col-sm-6 col-12">
                            <div class="footer-widget footer-menu-widget clearfix">
                                <h4 class="footer-title">Servizi</h4>
                                <div class="footer-menu">
                                    <ul>
                                        <li><a href="">Valutazioni</a></li>
                                        <li><a href="">Ristrutturare</a></li>
                                        <li><a href="">Progettare</a></li>
                                        <li><a href="">Consulenza</a></li>
                                        <li><a href="">Terms & Conditions</a></li>
                                        <li><a href="">Promotional Offers</a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-2 col-md-6 col-sm-6 col-12">
                            <div class="footer-widget footer-menu-widget clearfix">
                                <h4 class="footer-title">Legali</h4>
                                <div class="footer-menu">
                                    <ul>
                                        <li><a href="">Privacy Policy</a></li>
                                        <li><a href="">Termini del servizio</a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        
                    </div>
                </div>
            </div>
            <div class="ltn__copyright-area ltn__copyright-2 section-bg-7  plr--5">
                <div class="container-fluid ltn__border-top-2">
                    <div class="row">
                        <div class="col-md-6 col-12">
                            <div class="ltn__copyright-design clearfix">
                                <p>All Rights Reserved @ AD Servizi Immobiliari 2023</p>
                            </div>
                        </div>
                        <div class="col-md-6 col-12 align-self-center">
                            <div class="ltn__copyright-menu text-end">
                                <ul>
                                    <li><a href="#">Terms & Conditions</a></li>
                                    <li><a href="#">Claim</a></li>
                                    <li><a href="#">Privacy & Policy</a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </footer> 
    );
}